import React from "react";
import { Dropdown } from "react-bootstrap";
import { ChevronDown } from "lucide-react";

export const scopeLabelOf = (offices, value) => offices.find((item) => item.id === value)?.name || "You";

const ScopeMenu = ({ offices, value, onChange }) => (
  <Dropdown className="results-period-menu results-scope-menu" align="end">
    <Dropdown.Toggle variant="" className="results-period-menu__toggle" aria-label={`Showing ${scopeLabelOf(offices, value)}`}>
      <span className="results-period-menu__range">Showing</span>
      <span className="results-period-menu__label">
        {scopeLabelOf(offices, value)}
        <ChevronDown size={16} strokeWidth={2} aria-hidden="true" />
      </span>
    </Dropdown.Toggle>
    <Dropdown.Menu className="results-period-menu__list">
      <Dropdown.Item as="button" type="button" active={!value} aria-current={!value ? "true" : undefined} onClick={() => onChange(null)}>
        You
      </Dropdown.Item>
      {offices.map((office) => (
        <Dropdown.Item
          key={office.id}
          as="button"
          type="button"
          active={office.id === value}
          aria-current={office.id === value ? "true" : undefined}
          onClick={() => onChange(office.id)}
        >
          {office.name}, everyone
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

export default ScopeMenu;
